// extracted by mini-css-extract-plugin
export default {"root":"gift_campaigns_page_root__Pb7nh","createButton":"gift_campaigns_page_createButton__B8u+s"};